const { registerBlockType } = wp.blocks;
import { RichText, BlockControls,  AlignmentToolbar, FontSizePicker, PanelColorSettings, InspectorControls, MediaUpload } from '@wordpress/block-editor'
import { Fragment, useState } from '@wordpress/element'
import { PanelBody, Button, RangeControl, ToggleControl, SelectControl, TextControl, ToolbarGroup, ToolbarButton, __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalUnitControl as UnitControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl} from '@wordpress/components';
import { edit } from '@wordpress/icons';
const ALLOWED_MEDIA_TYPES = [ 'audio','image' ];
import 'animate.css';
const { __ } = wp.i18n;
import {fontfamilylist} from "./lib/fontfamilylist.js";
import {colors} from './lib/colors';

const BlockEdit = (props) => {
	const { className, attributes, setAttributes, clientId } = props;
	setAttributes({ uniqueid: 'spiceblocksimage' +clientId.slice(0,8) });
	const{uniqueid, title, imgfit, toggle, imgwidth, imgheight ,imgopacity, imgbrightness, imgcontrast, imgsaturate, imgblur,	imghue_rotate,  bgColor, captionColor, shadowColor, margins, paddings, captionpaddings, border, borderradius, fontfamily, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss }=attributes;

	const blockclass='image-upload-wrapper spice-blocks-image';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

 	const onFileSelect=(img)=>{
	  	props.setAttributes({
	  		imageUrl:img.url,
	  		imageID:img.id,
	  		imageAlt:img.alt,
	  	})
  	}
  	const onRemoveImg=()=>{
	  	setAttributes({
	  		imageUrl:null,
	  		imageID:null,
	  		imageAlt:null,
	  	});
	 }

  	const blockStyle = plugin.pluginpath + 'assets/images/dummy-image.jpg';

  	function setTitle(value) {
		setAttributes({title:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	
	function setcaptionColor(value) {
		setAttributes({captionColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setPaddings(value){
		setAttributes({
			paddings: {
					top: value,
					left: value,
					right: value,
					bottom: value
			}
		})		
	}
    
	if(fontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
	    let link = document.createElement('link')
	    link.href = url;
	    link.rel = "stylesheet";
	    link.type =  "text/css";
	      
	    if ( jQuery("body").hasClass("site-editor-php") ) { 
	      jQuery('iframe').contents().find("head").append(link);
      	}else{
      		document.head.appendChild(link);
      	}
    }  
    const colorSettingsarray =(toggle!=false) ? (
			[
				{
					value: bgColor,
					enableAlpha:true,
					clearable: true,
					onChange: setBgColor,
					label: __('Background','spice-blocks')
				},				
				{
					value: captionColor,
					enableAlpha:true,
					clearable: true,
					onChange: setcaptionColor,
					label: __('Caption Text','spice-blocks')
				},
			]):
    		([
				{
					value: bgColor,
					enableAlpha:true,
					clearable: true,
					onChange: setBgColor,
					label: __('Background','spice-blocks')
				},
			]);

  	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

  return (
  	<Fragment>
  		<style dangerouslySetInnerHTML={{
		  __html: [
		     `.spice-blocks-image#${uniqueid}{
					background-color:${bgColor};
					margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
					padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};						
					animation-delay: ${delay}ms;					
					
				}
				.spice-blocks-image#${uniqueid} img{
					box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};						
				}

				.spice-blocks-image#${uniqueid} img{
					border: ${border.width} ${border.style} ${border.color};
					border-top:${bordertop};
					border-right:${borderright};
					border-bottom:${borderbottom};
					border-left:${borderleft};
					border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						
					width: ${imgwidth}px;
  					height: ${imgheight}px;
  					opacity: ${imgopacity};
					object-fit: ${imgfit};
					filter: brightness( ${imgbrightness}% ) contrast( ${imgcontrast}% ) saturate( ${imgsaturate}% ) blur( ${imgblur}px ) hue-rotate( ${imghue_rotate}deg );
				}
				.spice-blocks-image#${uniqueid} span{
					font-size: ${titlefontSize};
					font-weight: ${TitleFontWeight};
					line-height: ${TitleLineHeight}px;
					font-family: ${fontfamily};
					text-transform:${TitleTransform};
					text-decoration:${TitleDecoration};
					letter-spacing:${TitleLetterSpacing}px;
					color:${captionColor};
					padding: ${captionpaddings.top} ${captionpaddings.right} ${captionpaddings.bottom} ${captionpaddings.left};
				}
				${customcss}`					
		    ].join('\n')
		  }}>
		</style>
		<InspectorControls>
			<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>				
				<ToggleControl
					label={__('Enable/Disable Text Caption','spice-blocks')}
					checked={attributes.toggle}
					onChange={(newval) => setAttributes({ toggle: newval })}
				/>
				<BoxControl 
					label={__('Margin','spice-blocks')}
					inputProps={{ min: -300 }}
					values={margins}
					sides={['top', 'bottom','left','right']}
					allowReset={false}
					units={[]}
					onChange={(newValue) =>
						setAttributes({
							...margins,
							margins: {
								top: newValue.top,
								left: newValue.left,
								right: newValue.right,
								bottom: newValue.bottom,
							},
						})
					}
				/>
      			<BoxControl
					values={paddings}
					label={__('Padding','spice-blocks')}					
					units={[]}
					allowReset={false}
					onChange={(newValue) =>
						setAttributes({
							...paddings,
							paddings: {
								top: newValue.top,
								left: newValue.left,
								right: newValue.right,
								bottom: newValue.bottom,
							},
						})
					}
				/>
				{ toggle == true && 
					[<>
						<BoxControl
							values={captionpaddings}
							label={__('Caption text Padding','spice-blocks')}
							units={[]}
							allowReset={false}
							onChange={(newValue) =>
								setAttributes({
									...captionpaddings,
									captionpaddings: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
							}
						/>
				 	</>]
				}

				<RangeControl 
					label={__('Width','spice-blocks')}			    
		      		value={ imgwidth}
        			onChange={(newtext) => setAttributes({ imgwidth: newtext })}
					min={0}
					max={2000}
				/>

				<RangeControl 
					label={__('height','spice-blocks')}			    
		      		value={ imgheight}
        			onChange={(newtext) => setAttributes({ imgheight: newtext })}
					min={0}
					max={2000}
				/>

				<RangeControl 
					label={__('Opacity','spice-blocks')}			    
		      		value={ imgopacity}
        			onChange={(newtext) => setAttributes({ imgopacity: newtext })}
					min={0.0}
					step={0.01}
					max={1.0}
					
				/>
				<SelectControl
		            label={__('Image Fit','spice-blocks')}
		            value={ imgfit }
		            options={ [
		                { label: __('Default','spice-blocks'), value: 'initial' },
		                { label: __('Fill','spice-blocks'), value: 'fill' },
		                { label: __('Cover','spice-blocks'), value: 'cover' },
		                { label: __('Contain','spice-blocks'), value: 'contain' },
		            ] }
		            onChange={ (newtext) => setAttributes({ imgfit: newtext }) }					  
		        />		        
				<BorderBoxControl
		            colors={ colors }
		            enableAlpha={'true'}
		            label={ __( 'Borders' ) }
		            onChange={(newtext) => setAttributes({ border: newtext })}
		            value={ border }       
		            
		        />
				<BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
			        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

			        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
			        
			        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

			        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
		        </BaseControl>
				<PanelBody initialOpen={false} title={__('Image Filter','spice-blocks')} className={'spice-panel-edit'}>	
					<RangeControl 
						label={__('Brightness','spice-blocks')}			    
					    value={ imgbrightness}
			        	onChange={(newtext) => setAttributes({ imgbrightness: newtext })}
						min={0}
						max={200}
					/>
					<RangeControl 
						label={__('Contrast','spice-blocks')}			    
					    value={ imgcontrast }
			        	onChange={(newtext) => setAttributes({ imgcontrast : newtext })}
						min={0}
						max={200}
					/>
					<RangeControl 
						label={__('Saturate','spice-blocks')}			    
					    value={ imgsaturate }
			        	onChange={(newtext) => setAttributes({ imgsaturate : newtext })}
						min={0}
						max={200}
					/>
					<RangeControl 
						label={__('Blur','spice-blocks')}			    
					    value={ imgblur}
			        	onChange={(newtext) => setAttributes({ imgblur: newtext })}
						min={0}
						step={0.1}
						max={10}
					/>
					<RangeControl 
						label={__('Hue-Rotate','spice-blocks')}			    
					    value={ imghue_rotate}
			        	onChange={(newtext) => setAttributes({ imghue_rotate: newtext })}
						min={0}
						max={360}
					/>
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
					<ToggleControl
						label={__('Enable/Disable on Desktop','spice-blocks')}
						checked={hidedesktop}
						onChange={(newval) => setAttributes({ hidedesktop: newval })}
					/>
					<ToggleControl
						label={__('Enable/Disable on Tablet','spice-blocks')}
						checked={hidetablet}
						onChange={(newval) => setAttributes({ hidetablet: newval })}
					/>
					<ToggleControl
						label={__('Enable/Disable on Mobile','spice-blocks')}
						checked={hidemobile}
						onChange={(newval) => setAttributes({ hidemobile: newval })}
					/>
				</PanelBody>

				<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
	        		<SelectControl
			            label={__('Animation','spice-blocks')}
			            value={ animation }
			            options={ [
			            	{ label: __('None','spice-blocks'), value: ' ' },
                            { label: __('Bounce','spice-blocks'), value: 'bounce' },
                            { label: __('Flash','spice-blocks'), value: 'flash' },
                            { label: __('Pulse','spice-blocks'), value: 'pulse' },
                            { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                            { label: __('Shake','spice-blocks'), value: 'shake' },
                            { label: __('Swing','spice-blocks'), value: 'swing' },
                            { label: __('Tada','spice-blocks'), value: 'tada' },
                            { label: __('Wobble','spice-blocks'), value: 'wobble' },
                            { label: __('Jello','spice-blocks'), value: 'jello' },
                            { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                            { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                            { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                            { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                            { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                            { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                            { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                            { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                            { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                            { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                            { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                            { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                            { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                            { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                            { label: __('Flip','spice-blocks'), value: 'flip' },
                            { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                            { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                            { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                            { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                            { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                            { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                            { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                            { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                            { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                            { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                            { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                            { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                            { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                            { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                            { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                            { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                            { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
		            	] }
	            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
	        		/>  
			        { animation != '' && (
			        	<>
					        <SelectControl
					            label={__('Durations','spice-blocks')}
					            value={ durations }
					            options={ [
					            	{ label: __('Normal','spice-blocks'), value: ' ' },
					                { label: __('Slow','spice-blocks'), value: 'slow' },
					                { label: __('Fast','spice-blocks'), value: 'fast' },
					            ] }
					            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
					        />  
				        	<TextControl
					            label={__('Delay(ms)','spice-blocks')}			    
					            value={delay}
		        				onChange={(newtext) => setAttributes({ delay: newtext })}
						    />
						</>
						)
					}
				</PanelBody>
			</PanelBody>		
			
			<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
				<RangeControl 
					label={ __('Horizontal Shadow(px)','spice-blocks') }			    
				    value={ hshadow}
				    onChange={(newtext) => setAttributes({ hshadow: newtext })}
					min={0}
					max={100}
				/>
				<RangeControl 
					label={ __('Vertical Shadow(px)','spice-blocks') }			    
				    value={ vshadow}
		        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
					min={0}
					max={100}
				/>	
				<RangeControl 
					label={ __('Blur Shadow(px)','spice-blocks') }			    
				    value={ blurshadow}
		        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
					min={0}
					max={100}
				/>
				<PanelColorSettings  initialOpen={true}
					className='spice-block-section-bg-color'
					title={ __('Box Shadow Color','spice-blocks') }
					colorSettings={[
						{
						value: shadowColor,
						enableAlpha:true,
						onChange: setShadowColor,
						label: __('Box Shadow','spice-blocks')
						},
					]}
				/>
			</PanelBody>

			<PanelBody initialOpen={false}	title={__('Background Settings','spice-blocks')}>
				<PanelColorSettings  className={'spice-blocks-color-style'}
					colorSettings={colorSettingsarray} 
				/>
			</PanelBody>			

			{ toggle == true && 
				[<>
					<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')} className={"spiceheadingtypo"} >
						<SelectControl
				            label={__(' Font Family','spice-blocks')}
				            value={ fontfamily }
				            options={fontfamilylist}
				            onChange={ (newtext) => setAttributes({ fontfamily: newtext }) }
				        />			        	
				        <FontSizePicker 
				        	__nextHasNoMarginBottom
				            value={ titlefontSize }		            
				            onChange={(userVal) => setAttributes({
										titlefontSize: userVal
									})}
				        />
				        <SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ TitleFontWeight }
				            options={ [
				               	{ label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (newtext) => setAttributes({ TitleFontWeight: newtext }) }					  
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}			    
						    value={ TitleLineHeight}
				        	onChange={(newtext) => setAttributes({ TitleLineHeight: newtext })}
							min={0}
							max={100}
						/>
						<SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ TitleTransform }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
				            ] }
				            onChange={ (newtext) => setAttributes({ TitleTransform: newtext }) }					  
			        	/>

				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ TitleDecoration }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Underline','spice-blocks'), value: 'underline' },
				                { label: __('Overline','spice-blocks'), value: 'overline' },
				                { label: __('Line Through','spice-blocks'), value: 'line-through' },
				            ] }
				            onChange={ (newtext) => setAttributes({ TitleDecoration: newtext }) }					  
				        />

				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ TitleLetterSpacing}
				        	onChange={(newtext) => setAttributes({ TitleLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>

		        	</PanelBody>
		        </>]
		    } 
		    <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                <InputControl
                    label={__('Additional Class','spice-blocks')}
                    value={ addclass }
                    onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                />
                <TextareaControl
                    label={__('Custom CSS','spice-blocks')}
                    value={ customcss }
                    onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                />
            </PanelBody>      				

		</InspectorControls>

		<BlockControls>
			<AlignmentToolbar
				value={attributes.textAlignment}
				onChange={(newalign) => setAttributes({ textAlignment: newalign })}
			/>			
		</BlockControls>

	  	<div  className={ `{"media-wrapper"} ${addclass}`}>
	  		{
	  		(props.attributes.imageUrl)?(
	  			<div id={uniqueid}
	  				className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass}`} >
	  				<div class="spice-img">
		  				<img
			  				src={props.attributes.imageUrl}
			  				alt={props.attributes.imageAlt}
		  				/>

		  				{(props.isSelected) ? (
		  					<BlockControls>
					            <ToolbarGroup>
							        <MediaUpload
						  				onSelect={onFileSelect}
						  				allowedTypes={ ALLOWED_MEDIA_TYPES }
						  				value={props.attributes.imageID}
						  				render={
						  					({open})=>
							  				<ToolbarButton
							                    icon={ edit }
							                    label={__('Edit','spice-blocks')}
							                    onClick={ open } 
							                />
							            }
									/>			                
					            </ToolbarGroup>
		        			</BlockControls>) : null }

		        		{(toggle!=false) ? (
							<RichText
								key="editable"
								tagName="span"
								className="spice-blocks-img-caption"
								placeholder={__('Enter Caption Here','spice-blocks')}
								value={title}
								onChange={setTitle}
							/>	):null 
						}
					</div>
				</div>
				):
				(					
					<MediaUpload
		  				onSelect={onFileSelect}
		  				allowedTypes={ ALLOWED_MEDIA_TYPES }
		  				value={props.attributes.imageID}
		  				render={
		  					({open})=>
			  				<Button
			  					className="spice-blocks-image-button"
			  					type="image"
				  				onClick={open}
			  				>
			  				<img src={blockStyle} width="50%" />
			  				</Button>
	  					}
					/>
				)
			}			 
		</div>
	</Fragment>
  );
};
 
registerBlockType('spice-blocks/spice-image', {
	title: __('Image','spice-blocks'),
	category: 'spice-blocks',
	icon: <svg width="23.999999999999996" height="23.999999999999996" xmlns="http://www.w3.org/2000/svg"><g><rect rx="1" stroke="#09A223" id="svg_1" height="18.74587" width="22.93729" y="2.62706" x="0.53135" fill="#fff" stroke-width="2"></rect><g id="svg_15"><g id="svg_13"><rect transform="rotate(45.7722 14.6715 13.3298)" rx="1" stroke-width="2" id="svg_11" height="6.44073" width="2.18812" y="10.10939" x="14.0774" fill="#09A223"></rect><rect transform="rotate(-46.9003 19.221 13.9235)" rx="1" stroke-width="2" id="svg_5" height="8.27758" width="2.18812" y="9.78467" x="18.62695" fill="#09A223"></rect><g id="svg_10"><rect transform="rotate(22.9389 3.91708 13.4961)" rx="1" stroke-width="5" id="svg_8" height="10.02146" width="2.18812" y="8.48539" x="3.32302" fill="#09A223"></rect><rect transform="rotate(-48.4641 10.2548 13.3219)" rx="1" stroke-width="5" id="svg_9" height="13.10192" width="2.18812" y="6.77092" x="9.66077" fill="#09A223"></rect></g></g><path transform="rotate(-63.8321 12.8496 7.80434)" id="svg_14" d="m14.07365,10.18058l0,0c-1.35189,0 -2.44804,-1.06369 -2.44804,-2.37624c0,-1.31238 1.09614,-2.37624 2.44804,-2.37624l0,0c-0.77044,0.56093 -1.22393,1.44135 -1.22393,2.37624s0.45349,1.81513 1.22393,2.37624z" stroke-width="4" fill="#09A223"></path></g></g></svg>,
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords: ['image','Spice Image','Image','spice-image'],
	attributes: {
	    uniqueid:{
			type:'string'
		},
		imageUrl: {
	      type: 'string',
	    },
	    imageID:{
	    	type:'number',
	    },
	    imageAlt:{
	      type: 'string',
	      source:'attributes',
	      attributes:'alt',
	      selector: 'img',
	    },
	    title:{
			type:'string',
		},
		imgfit:{
			type:'string',
			default:'initial'
		},
		toggle:{
			type: 'boolean',
			default: false
		},
		imgwidth:{
			type:'number'
		},
		imgheight:{
			type:'number'
		},
		imgopacity:{
			type:'number'
		},
		textAlignment: {
			type: 'string',
			default:'left'
		},
		imgbrightness:{
			type:'number',
			default:100
		},
		imgcontrast:{
			type:'number',
			default:100
		},
		imgsaturate:{
			type:'number',
			default:100
		}, 
		imgblur:{
			type:'number',
			default:0

		},
		imghue_rotate:{
			type:'number',
			default:0
		},
		bgColor:{
	    	type:'string',
	    },
	    captionColor:{
	    	type:'string',
	    	default:'#000',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
		margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
		captionpaddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
		border: {
            type: 'object',
            default: {
                color: '',
                style: '',
                width: '',        
            },
        },
        bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
    	hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		titlefontSize:{
			type:'string',
		},
		TitleFontWeight:{
			type:'string',
			default:'600'
		},
    	TitleLineHeight:{
	    	type:'number',
	    	default:58
	    },
	    hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    }, 
	    fontfamily:{
	    	type:'string',
	    	default:'Open Sans',
	    },
	    TitleTransform:{
	    	type:'string'
	    },
	    TitleDecoration:{
	    	type:'string'
	    },
	    TitleLetterSpacing:{
	    	type:'number'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},
	edit: BlockEdit,
	save: (props) => { 
		const { attributes } = props;
 		const{uniqueid, title, imgfit, toggle, imgwidth, imgheight, imgopacity, imgbrightness, imgcontrast, imgsaturate, imgblur, imghue_rotate, bgColor, captionColor, shadowColor, margins, paddings, captionpaddings, border, borderradius, fontfamily, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss }=attributes;

	  	const blockclass = 'image-upload-wrapper spice-blocks-image';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass = 'wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop = (hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet = (hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile = (hidemobile == false) ? 'hide-mobile' : '';
		const displayclass = displaydesktop+' '+displaytablet+' '+displaymobile;

		const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

		return(
		<>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `.spice-blocks-image#${uniqueid}{
						background-color:${bgColor};						
						animation-delay: ${delay}ms;
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};							
					}
					.spice-blocks-image#${uniqueid} img{
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};						
					}
					.spice-blocks-image#${uniqueid} img{
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						width: ${imgwidth}px;
	  					height: ${imgheight}px;
	  					opacity: ${imgopacity};
						object-fit: ${imgfit};
						filter: brightness( ${imgbrightness}% ) contrast( ${imgcontrast}% ) saturate( ${imgsaturate}% ) blur( ${imgblur}px ) hue-rotate( ${imghue_rotate}deg );
					}
					.spice-blocks-image#${uniqueid} span{
						font-size: ${titlefontSize};
						font-weight: ${TitleFontWeight};
						line-height: ${TitleLineHeight}px;
						font-family: ${fontfamily};
						text-transform:${TitleTransform};
						text-decoration:${TitleDecoration};
						letter-spacing:${TitleLetterSpacing}px;
						color:${captionColor};
						padding: ${captionpaddings.top} ${captionpaddings.right} ${captionpaddings.bottom} ${captionpaddings.left};
					}
					${customcss}`					
			    ].join('\n')
			  }}>
			</style>
			<script> 
				var fontfamily2=`{fontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
			</script>
			<div id={uniqueid} className = {`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`}>
				<div class="spice-img">
					<img
		  				src={props.attributes.imageUrl}
		  				alt={props.attributes.imageAlt}
		  			/>
		  			{(toggle!=false) ? (
			  			<RichText.Content 
							tagName="span"
							className="spice-blocks-img-caption"
							value={attributes.title}
						/>
						):null 
					}
				</div>
			</div>
		</>
		);		
	}
});